import type { ListItem } from '@/lib/eventBus/trackingEvents'

export const ITEM_LIST_BATCH_DELAY_MS = 300

export const createItemListBatcher = (onFlush: (items: ListItem[]) => void) => {
  const seenProductCodes = new Set<string>()
  let pendingItems: ListItem[] = []
  let flushTimer: ReturnType<typeof setTimeout> | undefined

  const flush = () => {
    flushTimer = undefined
    onFlush(pendingItems)
    pendingItems = []
  }

  const report = (item: ListItem) => {
    const productCode = item.product.code

    if (productCode == null || seenProductCodes.has(productCode)) {
      return
    }

    seenProductCodes.add(productCode)
    pendingItems.push(item)
    flushTimer ??= setTimeout(flush, ITEM_LIST_BATCH_DELAY_MS)
  }

  const reset = () => {
    clearTimeout(flushTimer)
    flushTimer = undefined
    pendingItems = []
    seenProductCodes.clear()
  }

  return { report, reset }
}
